<template>
  <v-row class="map-height">
    <v-col cols="12" v-if="systems">
      <l-map v-if="mapType === 'system'" :zoom="zoom" :center="center" style="height: 100%; width: 100%">
        <l-tile-layer :url="url" :attribution="attribution" />
        <l-marker
          v-for="item in systems"
          :key="item.system.id"
          :lat-lng="[item.system.geolat ? item.system.geolat : 0, item.system.geolng ? item.system.geolng : 0]"
          v-on:click="$emit('markerClicked',item)"
        >
          <l-tooltip :content="renderMarkersTooltip(item.system)" />
          <l-icon :icon-anchor="staticAnchor" class-name="someExtraClass">
            <img :src="chooseMapPin(item.system.sysstate, 'map')" width="30px" />
          </l-icon>
        </l-marker>
      </l-map>
      <l-map v-if="mapType === 'users'" :zoom="zoom" :center="center" style="height: 100%; width: 100%">
        <l-tile-layer :url="url" :attribution="attribution" />
        <l-marker
          v-for="item in systems"
          :key="item.id"
          :lat-lng="[item.geolat ? item.geolat : 0, item.geolng ? item.geolng : 0]"
          v-on:click="$emit('markerClicked',item)"
        >
          <l-tooltip :content="item.companyname" />
          <l-icon :icon-anchor="staticAnchor" class-name="someExtraClass">
            <img src="../../assets/icons/green-pin.png" width="30px" />
          </l-icon>
        </l-marker>
      </l-map>
    </v-col>
  </v-row>
</template>

<script>
import L from "leaflet";
import { LMap, LTileLayer, LMarker, LIcon, LTooltip } from "vue2-leaflet";
import { translateFunc } from "../../common/Filters.js"

export default {
  name: "AdminSystemsMap",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LTooltip
  },
  props: {
    mapType: {
      type: String,
      default: "system"
    },
    systemData: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      zoom: 8,
      center: L.latLng(56.426264, 9.957401),
      staticAnchor: [16, 37],
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      systems: []
    }
  },
  watch: {
    systemData: function(newVal){
      if(newVal.length){
        this.center = newVal[0].geolat ? L.latLng(newVal[0].geolat, newVal[0].geolng)
        : L.latLng(newVal[0].system.geolat, newVal[0].system.geolng);
      }
      this.systems = [...newVal];
      this.sortSystemData();
    }
  },
  mounted() {
    if(this.systemData && this.systemData.length){
      this.systems = [...this.systemData];
      this.sortSystemData();
    }
  },
  methods: {
    sortSystemData(){
      this.systems.sort((a, b) => {
        if (a.sysstate !== "1") {return -1;}
        return 0;
      });
    },
    chooseMapPin(status, type) {
      if (status === "0") {
        return type === "map" ? require("../../assets/icons/green-pin.png") : "status-0";
      } else if (status === "1") {
        return type === "map" ? require("../../assets/icons/red-pin.png") : "status-1";
      } else {
        return type === "map" ? require("../../assets/icons/grey-pin.png") : "status-other";
      }
    },
    renderMarkersTooltip(item){
      if (item.sysstate === "0") {
        return translateFunc('lng_marker_green');
      } else if (item.sysstate === "1") {
        return translateFunc('lng_marker_red');
      } else {
        return translateFunc('lng_marker_grey');
      }
    },
  }
}
</script>